import React, { useEffect, useState } from "react";
import styles from "../auth.module.css";
import { Input, notification, Modal } from "antd";
import { IoMailOutline, IoLockClosedOutline } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../utils/config";
import nftgif from "../../assests/images/nft.gif";
import newlogin from "../../assests/images/newlogin.jfif";

export default function Login() {
  const [userData, setUserData] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const userDataLocal = localStorage.getItem("user");
  const timeStamp = localStorage.getItem("timestamp");
  const user = userDataLocal ? JSON.parse(userDataLocal) : null;

  const handleLogin = async (e) => {
    if (e) e.preventDefault();
    if (loading) return;
    setLoading(true);

    try {
      const { data } = await axios.post(`${BASE_URL}login`, {
        ...userData,
      });

      if (!data) throw new Error("Invalid response from server");

      const token = data?.authorization?.token;
      const user = data?.user;

      // ✅ Save to localStorage
      if (token) localStorage.setItem("token", token);
      if (user) localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("timestamp", Date.now() + 3600 * 1000); // 1 hour expiry
      localStorage.setItem("time", Date.now());

      notification.success({ message: "Login successful" });

      // ✅ Reset form state
      setUserData({ email: "", password: "" });

      // ✅ Navigate based on user type
      if (["admin", "agent"].includes(user?.type)) {
        navigate("/admin");
      } else {
        navigate("/user");
      }
    } catch (error) {
      const errors = error?.response?.data?.errors;
      const message = error?.response?.data?.message;

      if (errors?.email) {
        notification.error({ message: errors.email[0] });
      } else if (errors?.password) {
        notification.error({ message: errors.password[0] });
      } else if (message) {
        notification.error({ message });
      } else {
        notification.error({ message: "Login failed. Please try again." });
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (timeStamp && Number(timeStamp) < Date.now()) {
      localStorage.removeItem("token");
      localStorage.removeItem("timestamp");
      setUserData((prev) => ({ ...prev, password: "" }));
      navigate("/login");
      return;
    }
    if (token && user) {
      if (user?.type === "admin" || user?.type === "agent") {
        navigate("/admin");
      } else if (user?.type === "user") {
        navigate("/user");
      }
    }
  }, []);

  return (
    !token && (
      <div className="min-h-screen flex">
        {/* Left Section */}
        <div className="hidden lg:flex flex-col justify-center items-center bg-gradient-to-br from-[#1d1f3f] to-[#18203d] w-1/2 p-10">
          <div>
            <h1 className="text-4xl font-bold text-white">
              Welcome to Element Us Labs
            </h1>
            <p className="text-lg text-gray-300 mt-4">
              The all-in-one solution for your cryptocurrency wallet, wallet
              management, and wallet tracking needs.
            </p>
          </div>
          <div className="mt-10">
            <img
              src={newlogin}
              alt="Crypto Character"
              className="w-64 h-64 object-cover shadow-lg rounded-md"
            />
          </div>
        </div>
        {/* Right Section */}
        <div className="flex flex-col justify-center bg-[#12122d] w-full lg:w-1/2 p-10">
          <h2
            className="text-3xl text-start font-semibold text-white mb-3"
            style={{ textTransform: "capitalize" }}
          >
            Log in to your account
          </h2>
          <div className="mb-8">
            <span className="text-white me-2">
              Not registered yet?
              <Link
                to="/signup"
                style={{
                  color: "#8F95B2",
                  fontWeight: "600",
                  borderBottom: "1px solid #8F95B2",
                  marginLeft: "5px",
                  cursor: "pointer",
                  fontSize: "16px",
                  textDecoration: "none",
                }}
              >
                Register
              </Link>
            </span>
          </div>
          <div className="mt-10 space-y-4">
            {/* Email Field */}
            <div>
              <label className="text-white mb-2 flex">Email address</label>
              <Input
                type="email"
                onKeyDown={(e) => e.key === "Enter" && handleLogin(e)}
                placeholder="Email Address"
                prefix={<IoMailOutline />}
                size="large"
                value={userData.email}
                onChange={(e) =>
                  setUserData({ ...userData, email: e.target.value })
                }
              />
            </div>

            {/* Password Field */}
            <div>
              <label className="text-white mb-2 flex">Password</label>
              <Input.Password
                onKeyDown={(e) => e.key === "Enter" && handleLogin(e)}
                placeholder="Min. 8 characters"
                prefix={<IoLockClosedOutline />}
                size="large"
                value={userData.password}
                onChange={(e) =>
                  setUserData({ ...userData, password: e.target.value })
                }
              />
            </div>

            {/* Forgot Password Link */}
            <div className="text-right">
              <Link
                to="/forgot-password"
                style={{
                  color: "#8F95B2",
                  fontWeight: "600",
                  borderBottom: "1px solid #8F95B2",
                  cursor: "pointer",
                  fontSize: "13px",
                  textDecoration: "none",
                }}
              >
                Forgot your password?
              </Link>
            </div>

            {/* Submit Button */}
            <div className="mt-6">
              <button
                disabled={loading || !userData.email || !userData.password}
                className={`${styles.LoginButton} w-full ${
                  loading ? "opacity-70" : ""
                }`}
                onClick={handleLogin}
              >
                {loading ? "Signing In..." : "Sign In"}
              </button>
            </div>
          </div>
        </div>

        {/* Verification Modal */}
        <Modal
          visible={loading}
          footer={null}
          closable={false}
          width={500}
          bodyStyle={{ padding: '24px' }}
          className="verification-modal"
        >
          <div className="text-center">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 border-4 border-gray-200 dark:border-gray-700 border-t-gray-900 dark:border-t-white rounded-full animate-spin"></div>
            </div>
            <h3 className="text-xl font-semibold text-gray-400 dark:text-white mb-2">
              Continuing to Verification — Security Step
            </h3>
            <p className="text-gray-400 dark:text-white mb-6">
              The system is performing checks and ensuring your privacy.
            </p>
            <div className="space-y-3 mb-6">
              <div className="flex items-center">
                <span className="w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-3">
                  <span className="text-xs font-medium text-gray-400 dark:text-white">1</span>
                </span>
                <span className="text-sm text-gray-400 dark:text-white">Check: Account Details Validity</span>
                <span className="ml-auto text-xs text-gray-400 dark:text-white">Not checked yet</span>
              </div>
              <div className="flex items-center">
                <span className="w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-3">
                  <span className="text-xs font-medium text-gray-400 dark:text-white">2</span>
                </span>
                <span className="text-sm text-gray-400 dark:text-white">Check: Login Source</span>
                <span className="ml-auto text-xs text-gray-400 dark:text-white">Not checked yet</span>
              </div>
              <div className="flex items-center">
                <span className="w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-3">
                  <span className="text-xs font-medium text-gray-400 dark:text-white">3</span>
                </span>
                <span className="text-sm text-gray-400 dark:text-white">Check: Quick Threat Scan</span>
                <span className="ml-auto text-xs text-gray-400 dark:text-white">Not checked yet</span>
              </div>
            </div>
            {/* <div className="text-xs text-gray-500 dark:text-gray-400 mb-4">Starting...</div> */}
            {/* <div className="flex justify-between">
              <button className="px-4 py-2 text-sm text-gray-500 dark:text-gray-400 border border-gray-300 dark:border-gray-600 rounded hover:bg-gray-50 dark:hover:bg-gray-800">
                Cancel
              </button>
              <button className="px-4 py-2 text-sm text-blue-600 dark:text-blue-400 border border-blue-300 dark:border-blue-600 rounded hover:bg-blue-50 dark:hover:bg-blue-900/10">
                Skip
              </button>
            </div>
            <div className="text-xs text-gray-400 dark:text-gray-500 mt-4 text-center">
              *This is a visual demo—no actual verification occurs.
            </div> */}
          </div>
        </Modal>
      </div>
    )
  );
}